import { AssetRetrieval } from "./assetRetrieval";

export type LabelPrintRequest = {
  id: string;
  state: string;
  boxType: string;
  labelUrl: string;
  missingAssetRetrievalsCount: number;
  assetRetrievalsCount: number;
};

export enum LabelPrintRequestStatus {
  pending = "pending",
  completed = "completed",
  failed = "failed",
}

export type LabelComponentInfo = {
  pendingCount: number;
  completedCount: number;
  nonProcessableOrders: AssetRetrieval[];
};

export type LabelComponentsInfo = {
  laptop: LabelComponentInfo;
  laptopTablet: LabelComponentInfo;
  laptopMobile: LabelComponentInfo;
  tablet: LabelComponentInfo;
  tabletMobile: LabelComponentInfo;
  mobilePhone: LabelComponentInfo;
  monitor: LabelComponentInfo;
  desktop: LabelComponentInfo;
  bulk: LabelComponentInfo;
};
